import _ from 'lodash';
import platformUtils from 'platformUtils';

class TypesUtil {
    constructor(typesData) {
        this.typesData = typesData;
    }

    /**
     * @typedef {Object} TypesData
     * @propery {Object} supportedComponentAPIs
     * @property {Object} viewerTypeToSdkTypeDefinitions
     */

    getPotentialViewerTypes(sdkType) {
        const typeUtils = platformUtils.getTypeUtils();
        return typeUtils.getPotentialViewerTypes(sdkType);
    }

    get possibleTypes() {
        const typeUtils = platformUtils.getTypeUtils();
        return _.get(typeUtils, 'Types');
    }

    get supportedComponentAPIs(){
        return this.typesData.supportedComponentAPIs;
    }

    getSdkConstructorName(compType, compData = {}) {
        const typeUtils = platformUtils.getTypeUtils();
        const widgetId = _.get(compData, ['widgetId']);
        return typeUtils.getSdkType(compType, widgetId);
    }

    getDefaultSdkType () {
        const typeUtils = platformUtils.getTypeUtils();
        return _.get(typeUtils, 'defaultSdkType');
    }

    setType(viewerType, sdkType) {
        const typeUtils = platformUtils.getTypeUtils();
        typeUtils.setType(viewerType, sdkType);
    }
}

export default TypesUtil;



// WEBPACK FOOTER //
// ./js/modules/privates/utils/types.es6